module.exports = __webpack_public_path__ + "img/ken.dd8a91b8.svg";